import styled from 'styled-components';
import { Collapse } from 'antd';
const { Panel } = Collapse;

export const FaqTitle = styled.h2`
  font-size: 1.5em;
  text-align: center;
  color: black;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;

  @media (max-width: 768px) {
    font-size: 1.3em;
  }

  @media (max-width: 480px) {
    font-size: 1.1em;
    padding: 0 0.5em;
  }
`;

export const StyledCollapse = styled(Collapse)`
   background-color: #fff;

  .ant-collapse-item > .ant-collapse-header {
    display: flex;
    align-items: center !important;
    gap: 0.75rem;
    padding-right: 1rem !important;
  }

  .ant-collapse-header-text {
    flex: 1;
    min-width: 0;
  }

  .ant-collapse-expand-icon {
    order: 2;
    margin-inline-start: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
  }

  .ant-collapse-arrow {
    position: static !important;
    inset: auto !important;
    margin: 0 !important;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus,
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus-visible,
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus-within {
    outline: 2px solid #111;
    outline-offset: 2px;
  }
`;

export const StyledPanel = styled(Panel)`
  display: block;
  justify-content: space-between;
  align-items: center;
  margin: 1em 0 1em;
  padding: 1em 1em;
  border-radius: 1em!important;
  border-bottom: 0!important;
  background-color: #f4f4f4;
  overflow-x: hidden;
  
  .ant-collapse-header-text {
    font-weight: 650;
    text-align: left;
    word-break: break-word;
  }

  a {
    color: #126CD1;
    overflow-wrap: break-word;
  }

  a:hover {
    color: #105CB7;
  }

  a:focus,
  a:focus-visible,
  a:focus-within {
    outline: 2px solid #111;
    outline-offset: 2px;
  }

  p {
    font-size: 13px;
    overflow-wrap: break-word;
  }

  @media (max-width: 768px) {
    padding: 0.75em 0.75em;
    margin: 0.75em 0 0.75em;
  }

  @media (max-width: 480px) {
    padding: 0.5em 0.5em;
    margin: 0.5em 0 0.5em;

    p {
      font-size: 12px;
    }

    a {
      font-size: 0.9em;
    }
  }
`;

export const QuestionTitle = styled.h3`
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
`;

export const StyledChevronIcon = styled.svg.attrs({
  'aria-hidden': 'true',
  focusable: 'false',
  viewBox: '0 0 24 24',
})<{ $isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.15rem;
  height: 1.15rem;
  padding: 0.18rem;
  box-sizing: content-box;
  line-height: 1;
  vertical-align: middle;
  border-radius: 999px;
  background-color: #e8e8e8;
  flex: 0 0 auto;
  pointer-events: none;
  transition: transform 180ms ease;
  will-change: transform;
  transform-origin: center;
  transform: rotate(${({ $isActive }) => (
    $isActive
      ? 180
      : 0
  )}deg) translate(1px, 2px);

  polyline {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;
